module.exports = __webpack_public_path__ + "static/media/Conf.3056eec0.png";